import script from "./NaNScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./NaNScreen.vue?vue&type=script&setup=true&lang=ts"

import "./NaNScreen.vue?vue&type=style&index=0&id=5935214c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5935214c"]])

export default __exports__